import { call, put, select, takeEvery } from "redux-saga/effects";
import { getUserUID } from "../auth/auth.selector";
import * as DepositActions from "./deposit.action";
import DepositAPI from "./deposit.api";
import { DepositActionTypes } from "./deposit.model";

export function* handleFetchDeposit(action) {
  try {
    const authUser = yield select(getUserUID);
    const response = yield call(DepositAPI.GetDeposits, action.payload, authUser);
    yield put(DepositActions.fetchDepositSuccess(response));
  } catch (e) {
    yield put(DepositActions.fetchDepositFailure(e));
  }
}

export function* handleRestratDeposit(action) {
  try {
    yield call(
      DepositAPI.SendHook,
      action.payload.id,
      action.payload.hash,
      action.payload.fromAddress
    );
    yield put(DepositActions.restartDepositSuccess(action.payload));
  } catch (e) {
    yield put(DepositActions.restartDepositFailure(e));
  }
}

export function* DepositSaga() {
  yield takeEvery(DepositActionTypes.FETCH_DEPOSIT_REQUEST, handleFetchDeposit);
  yield takeEvery(
    DepositActionTypes.RESTART_DEPOSIT_REQUEST,
    handleRestratDeposit
  );
}
